/**
 * Test if the current context as a global `window` object available.
 */
export function hasWindow() {
  return typeof window !== 'undefined';
}
